import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';

import './styles/globals.css';
import { AuthProvider } from './providers/AuthProvider/index';
import { ReportProvider } from '@/providers/ReportProvider/index';
import QueryProvider from '@/providers/QueryProvider/QueryProvider';
import { baseTheme } from './styles/base.theme';

const CLIENT_ID_GOOGLE = process.env.REACT_APP_CLIENT_ID_GOOGLE || 'client_id';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

console.log('CLIENT_ID_GOOGLE ==> ', process.env);
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={CLIENT_ID_GOOGLE}>
      <ChakraProvider theme={baseTheme}>
        <BrowserRouter>
          <QueryProvider>
            <AuthProvider isWeb={true}>
              <ReportProvider isWeb={true}>
                <Routes>
                  <Route path="/*" element={<App isWeb={true} />} />
                </Routes>
              </ReportProvider>
            </AuthProvider>
          </QueryProvider>
        </BrowserRouter>
      </ChakraProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
